









import { useQuery, useMutation, useQueryClient } from 'react-query';
import {

    GetAllOrderDesignHistoryWithTotal,
    SimpleGetAllOrders,
    AddOrderDesignHistory,
    UpdateOrderDesignHistory,
    DeleteOrderDesignHistory,
    GetDesignerPerformance


} from '../Api/index';



// http://192.168.3.17:91/api/v1/OrderDesignHistory/GetAllOrderDesignHistoryWithTotal

const useGetAllOrderDesignHistoryWithTotal = (body) => {

    return useQuery(['GetAllOrderDesignHistoryWithTotal', body], GetAllOrderDesignHistoryWithTotal, {
        enabled: !!body,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        cacheTime: Infinity,
        onSuccess: (data) => {

        },
        onError: (err) => {
        }
        ,
        select: (data) => {
            let rawData = data?.data;
            return rawData
        }
    })


}

const useSimpleGetAllOrders = (body) => {

    return useQuery(['SimpleGetAllOrders', body], SimpleGetAllOrders, {
        enabled: !!body,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        cacheTime: Infinity,
        onSuccess: (data) => {

        },
        onError: (err) => {
        }
        ,
        select: (data) => {
            let rawData = data?.data?.data;
            return rawData
        }
    })


}

const useAddOrderDesignHistory = () => {
    const queryClient = useQueryClient();
    // const dispatch = useDispatch()
    return useMutation(AddOrderDesignHistory, {

        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllOrderDesignHistoryWithTotal');
        },
        onError: (err) => {

        }
    })
}


    const useUpdateOrderDesignHistory = () => {
    const queryClient = useQueryClient();
    // const dispatch = useDispatch()
    return useMutation(UpdateOrderDesignHistory, {

        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllOrderDesignHistoryWithTotal');
        },
        onError: (err) => {

        }
    })
}

const useDeleteOrderDesignHistory = () => {
    const queryClient = useQueryClient();
    // const dispatch = useDispatch()
    return useMutation(DeleteOrderDesignHistory, {

        onSuccess: (data) => {
            queryClient.invalidateQueries('GetAllOrderDesignHistoryWithTotal');
        },
        onError: (err) => {

        }
    })
}

const useGetDesignerPerformance = (body) => {

    return useQuery(['GetDesignerPerformance', body], GetDesignerPerformance,{
        enabled: !!body,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        cacheTime: Infinity,
        onSuccess: (data) => {

        },
        onError: (err) => {
        }
        ,
        select: (data) => {
            let rawData = data?.data?.data;
            return rawData
        }
    })


}







export {
    useGetAllOrderDesignHistoryWithTotal,
    useSimpleGetAllOrders,
    useAddOrderDesignHistory,
    useUpdateOrderDesignHistory,
    useDeleteOrderDesignHistory,
    useGetDesignerPerformance
}






